import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface ISiteVisitJobCost extends IModel {
	siteVisitKey?: string;
	jobCostKey?: string;
	changeOrderKey?: string;
	installSheetKey?: string;
}

const siteVisitJobCostFactory = modelFactory.createFactory<ISiteVisitJobCost>('SiteVisitJobCost', _.assign({}, model, {
	siteVisitKey: {
		setFilters: valueFilters.clean
	},
	jobCostKey: {
		setFilters: valueFilters.clean
	},
	changeOrderKey: {
		setFilters: valueFilters.clean
	},
	installSheetKey: {
		setFilters: valueFilters.clean
	}
}));

export default siteVisitJobCostFactory;